// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishListNew/Selected.less
// module id = 950
// module chunks = 0